import { doRequest } from '@r1-frontend/do-request';
import { getInfoAll } from '@r1-frontend/api-domru/api-profile/v2/info/all';
import { ResponseContactDto } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { getAgreementNumber } from '@r1-frontend/shared/helpers/getAgreementNumber';

import { TAppThunkDispatch, TGetState } from '~/src/store';
import { clientContactsLoading, setClientContacts } from '~/src/store/actionCreators/auth';
import { logout } from '~/src/store/actions/auth/logout';
import { parseContacts } from '~/src/store/actions/clientInfo';

export function getClientContacts() {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const state = getState();
        if (!state.auth.isAuth) {
            return;
        }
        if (state.auth.isClientContactsLoading) {
            return;
        }

        const providerId = state.city.provider.providerId;
        const accessToken = state.auth.accessToken;
        const agreementNumber = getAgreementNumber();

        const resp = await doRequest.apiProfile<ResponseContactDto>(
            getInfoAll(providerId, accessToken, agreementNumber, ['contacts']),
        );
        if (resp.isSuccess) {
            const { contacts } = resp.payload;
            dispatch(setClientContacts(parseContacts(contacts)));
        } else if (resp.error.code.toString() === '401') {
            dispatch(logout());
        }

        dispatch(clientContactsLoading(false));
    };
}
